import React from 'react'
import styles from './ResourceItem.module.css'
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import { useStateValue } from '../../../StateProvider';
import axios from '../../../axios';
import moment from 'moment'

function ResourceItem({orgName, personnelName, address, contactNumber, state, city, units,type,updatedDate, id, resourceClass}) {

    let history = useHistory();
    const [{loggedIn,loginInfo,currentPage}, dispatch] = useStateValue()


    const checkLoginNR = async () => {
        if(loggedIn){
            await axios.patch(`/updateResources/reportAsNotResponding/${id}`,{
                reportingEmail: loginInfo.profileObj.email
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else{
            //create a context state to track whether the forReport Login is true or not
            history.push('/login')
        }
    }

    const checkLoginAP = async () => {
        if(loggedIn){
            await axios.patch(`/updateResources/reportAsInappropriate/${id}`,{
                reportingEmail: loginInfo.profileObj.email
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else{
            history.push('/login')
        }
    }

    return (
        <div className={styles.component}>
            <div className={styles.details}>
                <span className={styles.name}>{orgName}</span><br/>

                <span className={styles.city}>{address}</span><br/>
                <span className={styles.city}>{city}, {state}.</span><br/>


                <span className={styles.city}>Contact:&nbsp;{personnelName} ( {contactNumber} )</span><br/><br/>
                


                <h1 className={styles.sideHead}> Resource Type: <span className={styles.highlight}>{type}</span></h1>
                {resourceClass ? (<><h1 className={styles.sideHead} > {type === 'food' ? 'Food' : 'Blood'} type: <span className={styles.highlight}>{resourceClass}</span></h1><br/></>) : null}

                {type !== 'food' ? (<><h1 className={styles.sideHead}> Units Available: <span className={styles.highlight}>{units}</span></h1><br/></>) : null}
                
                <span className={styles.date}>Updated On: {moment(updatedDate).calendar()}</span>
            </div><br/>

            <div className={styles.divider}/>
            <div className={styles.notresponding}>
            
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<i className='fas fa-exclamation-circle' />}
                    className={styles.notRespond}
                    onClick={checkLoginNR}
                >
                    Mark as not responding
                </Button> 

                <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<i className='fas fa-exclamation-circle' />}
                    className={styles.notRespond}
                    onClick={checkLoginAP}
                >
                    Mark as inappropriate
                </Button> 
            </div>

        </div>
    )
}

export default ResourceItem
